import { HTTP } from "../../service/http-common";

// initial state
const state = () => ({
   specialists: null,
   updatedData: null,
   deletedData: null,
   createdData: null,
});

// getters
const getters = {
   getAll: (state) => state.specialists,
};

// actions
const actions = {
   fetchAllSpecalists({ commit }) {
      return new Promise((resolve, reject) => {
         HTTP.get("v1/specialists")
            .then((response) => {
               commit("setSpecialists", response.data.data);
               resolve(response.data.data);
            })
            .catch((error) => {
               reject(error);
            });
      });
   },
   create({ commit }, specialist) {
      return new Promise((resolve, reject) => {
         HTTP.post("v1/specialists", specialist)
            .then((response) => {
               commit("saveCreatedSpecialist", response.data);
               resolve(response.data);
            })
            .catch((error) => {
               reject(error);
            });
      });
   },
   update({ commit }, specialist) {
      return new Promise((resolve, reject) => {
         HTTP.put("v1/specialists/" + specialist.id, specialist)
            .then((response) => {
               commit("saveUpdatedSpecialist", response.data);
               resolve(response.data);
            })
            .catch((error) => {
               reject(error);
            });
      });
   },
   delete({ commit }, id) {
      return new Promise((resolve, reject) => {
         HTTP.delete("v1/specialists/" + id)
            .then((response) => {
               commit("deleteSpecialist", response.data);
               resolve(response.data);
            })
            .catch((error) => {
               reject(error);
            });
      });
   },
};

// mutations
const mutations = {
   setSpecialists: (state, specialists) => {
      state.specialists = specialists;
   },
   saveCreatedSpecialist: (state, specialist) => {
      state.createdData = specialist;
   },
   saveUpdatedSpecialist: (state, specialist) => {
      state.updatedData = specialist;
   },
   deleteSpecialist: (state, id) => {
      state.deletedData = id;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
